/* eslint-disable no-useless-escape */
import { UtilsService } from '@/services';
import numeral from 'numeral';
const { v1: generateId } = require('uuid');
const bowserDetect = require('bowser');
import getSymbolFromCurrency from 'currency-symbol-map';

const _numeral = numeral;

import {
    FB_REQUEST_OPTION,
    LOCAL_STORAGE_KEYS,
    MEMBER_STATUS,
} from '@consts';

import {
    bindCallback,
    timer,
    of,
    fromEvent,
    throwError,
    Subject,
    merge,
} from 'rxjs';

import {
    map,
    switchMap,
    first,
    mergeMap,
    scan,
    pluck,
    catchError,
    filter,
    timeout,
    share,
    partition,
    takeUntil,
    take,
} from 'rxjs/operators';
import moment from 'moment';

import _result from 'lodash/result';
import { stringify } from 'qs';
import * as common from 'adriel_backandfrontcommon';

import memoize from 'lodash/memoize';

const result = R.flip(R.binary(_result));

const destIfElse = R.ifElse(R.identity, R.__, R.always(undefined));

const isIE = R.path(['navigator', 'msSaveBlob'], window);

var prependImageDest = destIfElse(
    R.unless(
        R.anyPass([
            R.startsWith(process.env.VUE_APP_API_URL),
            R.startsWith('http'),
        ]),
        R.compose(
            R.concat(process.env.VUE_APP_API_URL || '/api'),
            R.concat('/images')
        )
    )
);

var prependFileDest = destIfElse(
    R.unless(
        R.anyPass([
            R.startsWith(process.env.VUE_APP_API_URL),
            R.startsWith('api'),
        ]),
        R.compose(
            R.concat(process.env.VUE_APP_API_URL || '/api'),
            R.concat('/files')
        )
    )
);

var prependPublicImageDest = destIfElse(
    R.unless(
        R.anyPass([
            R.startsWith(process.env.VUE_APP_URL),
            R.startsWith('http'), //maybe already appended
        ]),
        R.compose(R.concat(process.env.VUE_APP_URL || 'https://demo.adriel.ai'))
    )
);

function isValidEmail(email, isValid) {
    if (typeof isValid !== 'function') {
        isValid = R.T;
    }
    var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email) && isValid(email);
}

const isValidUrl = (url, forbiddens = []) => {
    url = R.compose(
        (url) => (/^https?:\/\//g.test(url) ? url : `http://${url}`),
        R.trim,
        R.toLower,
        (url) => url || ''
    )(url);

    forbiddens = testerFromArray([...forbiddens, 'facebook.com']);

    const rawUrl = url;
    // after encoding some special characters inserted
    url = encodeURIComponent(url);

    return (
        !forbiddens(url) &&
        !forbiddens(rawUrl) &&
        !!/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,10}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
            url
        )
    );
};

function isValidAppStoreUrl(url) {
    if (isValidUrl(url)) {
        return (
            url.indexOf('itunes.apple.com') !== -1 ||
            url.indexOf('apps.apple.com') !== -1
        );
    }
    return false;
}

function isValidPlayStoreUrl(url) {
    if (isValidUrl(url)) {
        return url.indexOf('play.google.com') !== -1;
    }
    return false;
}

function isValidPhoneNumber(number) {
    var re = /^([0-9\(\)\/\+ \-]*)$/;
    return re.test(number);
}

var prependCurrency = R.concat('$ ');

function delimitNumbers(str) {
    if (isNaN(str)) {
        return str;
    }
    return (str + '').replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
        return (
            (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.')
                ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
                : b) + c
        );
    });
}

function removeZeros(value) {
    if (isNaN(value)) {
        return value;
    }
    value = String(value);
    if (value.indexOf('.') < 0) {
        return value;
    }

    value = value.split('.').map(R.split(''));

    while (value[1][value[1].length - 1] == 0) {
        value[1].pop();
    }

    if (value[1].length) {
        value[0].push('.');
    }

    return value[0].concat(value[1]).join('');
}

var makeFixedComma = (num = 2) => {
    return R.compose(
        delimitNumbers,
        removeZeros,
        R.ifElse(isNaN, R.identity, (value) => value.toFixed(num)),
        R.ifElse(isNaN, R.identity, Number)
    );
};

var fixedComma = (value, format = '0.00') =>
    removeZeros(_numeral(value).format(format));

var adjustAndCurrency = R.compose(prependCurrency, fixedComma);

const _defaultString = R.ifElse(R.identity, R.identity, R.always(''));

var upperHead = R.compose(
    R.converge(R.concat, [R.compose(R.toUpper, R.head), R.tail]),
    _defaultString
);

const upperWords = R.compose(
    R.join(' '),
    R.map(upperHead),
    R.split(' '),
    R.trim(),
    _defaultString
);

function isDate(x) {
    return null != x && !isNaN(x) && 'undefined' !== typeof x.getDate;
}

var toDate = (date) => {
    if (!date) {
        return;
    }
    return isDate(date || undefined) ? date : new Date(date);
};

var isInRange = (value, min, max) => {
    return R.both(R.gte(R.__, min), R.lte(R.__, max))(value);
};

var mapPosition = (key) => {
    return (
        {
            feed: 'News Feed',
            instagram_stories: 'Story',
            instagram_standard: 'News Feed',
            desktop_feed_standard: 'News Feed',
        }[key] || key
    );
};

var makeExtensionChecker = R.curry((extensions, file) =>
    R.anyPass(extensions.map((e) => R.endsWith(e)))(file)
);

function getFbLoginStatus() {
    return new Promise((resolve, reject) => {
        var [connected, disconnected] = bindCallback(
            window.FB.getLoginStatus
        )().pipe(share(), partition(R.propEq('status', 'connected')));

        connected
            .pipe(
                pluck('authResponse', 'accessToken'),
                switchMap((token) => (token ? of(token) : throwError()))
            )
            .subscribe(resolve, reject);

        disconnected.subscribe(reject, reject);
    });
}

function fbLogin(callback, reject, authType) {
    window.FB.login(
        (res) => {
            const token = R.path(['authResponse', 'accessToken'], res);
            if (token) {
                UtilsService.fbInfo(token).then(callback, reject);
            } else {
                reject({
                    code: 'FB_LOGIN_ERROR',
                });
            }
        },
        { ...FB_REQUEST_OPTION, auth_type: authType }
    );
}

function getFacebookPages({ token, authType }) {
    return new Promise((resolve, reject) => {
        const callback = (data) => {
            const permissions = data.permissions.data
                .filter((p) => p.status !== 'declined')
                .map(R.prop('permission'));

            const requiredPermissions = [
                'manage_pages',
                'business_management',
                'ads_management',
            ];
            if (
                !requiredPermissions.every((p) => permissions.indexOf(p) > -1)
            ) {
                reject({
                    code: 'PERMISSIONS_MISSING',
                    data: data.permissions.data,
                });
            } else resolve(data);
        };
        if (token) {
            UtilsService.fbInfo(token).then(callback, reject).catch();
        } else {
            fbLogin(callback, reject, authType);
        }
    });
}

function isDoubleWidthCharacter(x) {
    if (x === '\n') return true;
    x = x.charCodeAt();
    return (
        x >= 0x1100 &&
        (x <= 0x115f || // Hangul Jamo
            x === 0x2329 || // LEFT-POINTING ANGLE BRACKET
            x === 0x232a || // RIGHT-POINTING ANGLE BRACKET
            // CJK Radicals Supplement .. Enclosed CJK Letters and Months
            (0x2e80 <= x && x <= 0x3247 && x !== 0x303f) ||
            // Enclosed CJK Letters and Months .. CJK Unified Ideographs Extension A
            (0x3250 <= x && x <= 0x4dbf) ||
            // CJK Unified Ideographs .. Yi Radicals
            (0x4e00 <= x && x <= 0xa4c6) ||
            // Hangul Jamo Extended-A
            (0xa960 <= x && x <= 0xa97c) ||
            // Hangul Syllables
            (0xac00 <= x && x <= 0xd7a3) ||
            // CJK Compatibility Ideographs
            (0xf900 <= x && x <= 0xfaff) ||
            // Vertical Forms
            (0xfe10 <= x && x <= 0xfe19) ||
            // CJK Compatibility Forms .. Small Form Variants
            (0xfe30 <= x && x <= 0xfe6b) ||
            // Halfwidth and Fullwidth Forms
            (0xff01 <= x && x <= 0xff60) ||
            (0xffe0 <= x && x <= 0xffe6) ||
            // Kana Supplement
            (0x1b000 <= x && x <= 0x1b001) ||
            // Enclosed Ideographic Supplement
            (0x1f200 <= x && x <= 0x1f251) ||
            // CJK Unified Ideographs Extension B .. Tertiary Ideographic Plane
            (0x20000 <= x && x <= 0x3fffd))
    );
}

const countCharacters = R.pipe(
    R.defaultTo(''),
    R.split(''),
    R.reduce((acc, c) => (isDoubleWidthCharacter(c) ? acc + 2 : acc + 1), 0)
);

const genericRetryStrategy =
    (max = 3, step = 500) =>
    (attempts) =>
        attempts.pipe(
            scan(
                (acc, error) => {
                    return {
                        error,
                        count: R.inc(acc.count),
                    };
                },
                { error: null, count: 0 }
            ),
            mergeMap(({ error, count }) =>
                count > max ? throwError(error) : timer(count * step)
            )
        );

const isValueExist = R.both(R.complement(R.isNil), R.complement(R.isEmpty));

const noValueExist = R.complement(isValueExist);

export const log = (v) => console.log('[Ramda Log]: ', v) || v;

const initGapi = R.once(() => {
    gapi.auth2.init({
        apiKey: 'AIzaSyC2FcgGiOUP7W24bkNjOntUVQttW-ezJf4',
        discoveryDocs: [
            'https://www.googleapis.com/discovery/v1/apis/analytics/v3/rest',
        ],
        clientId:
            '530609157666-cet4nhbec4uo9fuo5en09kq6ogglou68.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.manage.users',
    });
});

const getGa = async () => {
    initGapi();
    const auth = gapi.auth2.getAuthInstance();
    await auth.signIn({
        prompt: 'select_account',
    });
    const { result: { username = '', items = [] } = {} } =
        await gapi.client.analytics.management.webproperties.list({
            accountId: '~all',
        });

    return {
        username,
        properties: items
            .filter(
                R.compose(
                    R.propEq('length', 2),
                    R.intersection(['EDIT', 'MANAGE_USERS']),
                    R.pathOr([], ['permissions', 'effective'])
                )
            )
            .map(R.pick(['accountId', 'id', 'name', 'websiteUrl'])),
    };
};

function insertGa({ accountId, propertyId, gaEmails = [] }) {
    return Promise.all(
        gaEmails.map(
            (email) =>
                new Promise((resolve, reject) => {
                    gapi.client.analytics.management.webpropertyUserLinks
                        .insert({
                            accountId,
                            webPropertyId: propertyId,
                            resource: {
                                permissions: {
                                    local: ['EDIT', 'MANAGE_USERS'],
                                },
                                userRef: {
                                    email,
                                },
                            },
                        })
                        .execute((res = {}) =>
                            res.error ? reject() : resolve()
                        );
                })
        )
    );
}

const headFromArray = R.ifElse(Array.isArray, R.head, R.identity);

function makeThumb(input = []) {
    return of(input)
        .pipe(
            map(headFromArray),
            filter(R.identity),
            mergeMap((input) => {
                const reader = new FileReader();
                const observable = fromEvent(reader, 'load').pipe(
                    map(R.path(['target', 'result'])),
                    first()
                );
                reader.readAsDataURL(input);
                return observable;
            }),
            catchError((err) => {
                console.log(err);
            })
        )
        .toPromise();
}

function getImgSize(src) {
    return of(new Image())
        .pipe(
            mergeMap((image) => {
                const observable = fromEvent(image, 'load').pipe(
                    pluck('target'),
                    map(R.pick(['width', 'height'])),
                    timeout(3000),
                    catchError(() => of({ width: 1, height: 1 })),
                    first()
                );

                image.src = src;
                return observable;
            })
        )
        .toPromise();
}

function getVideoMeta(file) {
    return new Promise((resolve, reject) => {
        try {
            let video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = function () {
                resolve(this);
            };
            video.onerror = function (error) {
                reject(error);
            };
            video.src = window.URL.createObjectURL(file);
        } catch (error) {
            reject(error);
        }
    });
}

const isVideoType = R.compose(
    R.test(/^.*\.(avi|AVI|wmv|WMV|flv|FLV|mpg|MPG|mp4|MP4|mov|m4v)$/),
    R.toLower,
    R.defaultTo('')
);

const isImageType = R.compose(
    R.test(/^.*\.(jpg|jpeg|png|svg)$/),
    R.toLower,
    R.defaultTo('')
);

function isUrl(str) {
    const regexp =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    return regexp.test(str);
}

function prependImageDestObject(obj, fieldNames = ['image', 'media']) {
    const _contains = R.contains(R.__, fieldNames);
    return R.pipe(
        R.ifElse(R.identity, R.clone, R.always({})),
        R.mapObjIndexed((value, key) =>
            _contains(key) ? prependImageDest(value) : value
        )
    )(obj);
}

function extractHostname(url) {
    let hostname;
    if (!url) return '';
    if (url.indexOf('//') > -1) {
        hostname = url.split('/')[2];
    } else {
        hostname = url.split('/')[0];
    }
    //find & remove "?"
    hostname = hostname.split('?')[0];
    return hostname;
}

function getExtension(file) {
    if (!file) return;
    return file.substring(file.lastIndexOf('.') + 1, file.length).toLowerCase();
}

const countDouble = (value = '') => (isDoubleWidthCharacter(value) ? 2 : 1);

function truncStr(value = '', maxChars, counter) {
    if (typeof value !== 'string') {
        return value;
    }
    counter = counter || countDouble;
    let nbOfChars = 0;
    let i = 0;
    const charsLength = value.length;
    for (i = 0; i < charsLength; i++) {
        nbOfChars += counter(value[i]);
        if (nbOfChars > maxChars) {
            i--;
            break;
        } else if (nbOfChars === maxChars) {
            break;
        }
    }

    return value.substr(0, i + 1);
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const filterIdentity = R.filter(R.identity);

function getLang(user = {}) {
    //if user language exists
    //return user language
    var lang = R.prop(['language'], user);

    if (lang) {
        return lang;
    }

    const asIs = new Set(['en']);
    const maybeKorean = (lang) => new Set(['kr', 'ko']).has(lang);
    const maybeJapanese = (lang) => new Set(['ja', 'jpn']).has(lang);
    let target = 'en';

    var paramLang = getParameterByName('lang');
    if (maybeKorean(paramLang)) {
        return 'ko';
    } else if (maybeJapanese(paramLang)) {
        return 'ja';
    } else if (asIs.has(paramLang)) {
        return paramLang;
    }

    var localLang = getLocalStorage('lang');

    if (maybeKorean(localLang)) {
        return 'ko';
    } else if (maybeJapanese(localLang)) {
        return 'ja';
    } else if (localLang === 'en') {
        return localLang;
    }

    // useless after ja deploy
    // const planType = getQueryStringParams('planType');
    // if (planType === 'T') {
    //     return 'en';
    // } else if (planType === 'A') {
    //     return 'ko';
    // }

    lang = R.compose(
        R.defaultTo(''),
        R.head,
        filterIdentity,
        R.props(['userLanguage', 'language']),
        R.prop('navigator')
    )(window);

    if (lang.includes('-')) lang = R.compose(R.head, R.split('-'))(lang);

    if (maybeKorean(lang)) {
        target = 'ko';
    } else if (maybeJapanese(lang)) {
        target = 'ja';
    }

    return target;
}

function setLocalStorage(key, value) {
    var storage = window.localStorage;
    if (!storage) {
        return;
    }

    if (typeof value !== 'string') {
        try {
            value = JSON.stringify(value);
        } catch (e) {
            console.log('failed to stringify');
        }
    }

    storage.setItem(key, value);
}

function getLocalStorage(key, defaultValue) {
    var storage = window.localStorage;
    if (!storage) {
        return;
    }

    const value = storage.getItem(key);

    if (value) {
        return value;
    } else {
        return defaultValue === undefined ? null : defaultValue;
    }
}

export function removeLocalStorageItem(key) {
    var storage = window.localStorage;
    if (!storage) {
        return;
    }

    storage.removeItem(key);
}

function capitalize(string = '') {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function isValidBrowser() {
    const browser = bowserDetect.getParser(window.navigator.userAgent);
    var { name, version } = browser.getBrowser();

    if (name === 'Internet Explorer' && Number(version) < 11) {
        return false;
    }

    return true;
}

function isKakaoBrowser() {
    return /KAKAOTALK/.test(window.navigator.userAgent);
}

function formatNumber({
    number,
    format = '0.0a',
    fallback = 'N/A',
    locale = '',
    isKoreanFormat = false,
}) {
    if (isKoreanFormat) {
        return number;
    } else {
        if (locale) _numeral.locale(locale);
        var ret =
            Number.isInteger(number) && number < 1000
                ? number
                : _numeral(number).format(format);

        if (Number.isInteger(Number(ret))) {
            return parseInt(ret);
        } else {
            return isNaN(parseFloat(ret)) ? fallback : ret;
        }
    }
}

function _formatCurrency(nb, options = {}) {
    const { toFixed, format, currency } = options;
    if (toFixed) {
        nb = this.toFixed(nb, toFixed);
    }

    const defaultFormat = currency === 'KRW' ? '0,0' : '0,0.[00]';
    const finalFormat = format || defaultFormat;

    nb = _numeral(nb).format(finalFormat);
    nb = Number.isInteger(Number(nb)) ? parseInt(nb) : nb;

    switch (currency) {
        case 'USD':
            return `US$ ${nb}`;
        case 'KRW':
            return `₩ ${nb}`;
        case 'GBP':
            return `£ ${nb}`;
        default: {
            const symbol = getSymbolFromCurrency(currency) || '$';
            return `${nb} ${symbol}`;
        }
    }
}

const formatCurrency = memoize(_formatCurrency, (nb, options = {}) =>
    JSON.stringify({ nb, ...options })
);

function isMobile() {
    var isMobile = false;
    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            navigator.userAgent.substr(0, 4)
        )
    ) {
        isMobile = true;
    }
    return isMobile;
}

const toPercent = R.ifElse(
    isNaN,
    R.always('-'),
    (value) => (value * 100).toFixed(2) + '%'
);

const resizeInput = (elem, buffer = 0) => {
    let style = elem.style;
    const cHeight = parseFloat(style.height);

    style.height = '5px';
    let height = elem.scrollHeight;
    if (elem.value && !elem.value.trim()) {
        height += 5;
    }
    if (buffer && isInRange(height, cHeight - buffer, cHeight + buffer)) {
        height = cHeight;
    }

    style.height = `${height}px`;
};

function downloadFile({ uri, name, blob }) {
    if (isIE) {
        if (uri) window.open(uri, '_blank');
        if (blob) window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
        const link = document.createElement('a');
        link.download = name;
        link.setAttribute('target', '_blank');
        link.href = blob ? URL.createObjectURL(blob) : uri;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}

function endsWithPunctuation(value = '') {
    return /[\‒\–\—\―|$&~=\\\/⁄@+*!?({[\]})<>‹›«».;:^‘’“”'",،、`·\•†‡°″¡¿※#№÷×%‰\−‱¶′‴§_‖¦]+$/.test(
        value
    );
}

const attachProtocol = R.ifElse(
    R.test(/https?:\/\//gi),
    R.identity,
    R.concat('http://')
);

function blur() {
    R.when(R.identity, result('blur'))(window.document.activeElement);
}

function height(el) {
    return isValueExist(el)
        ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
        : 0;
}

function outerWidth(el, includeMargin) {
    if (!isValueExist(el)) {
        return 0;
    }

    if (includeMargin === true) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
    } else {
        return el.offsetWidth;
    }
}

function deleteElement(el = {}) {
    el.parentNode && el.parentNode.removeChild(el);
}

function allValueExist(...rest) {
    return R.all(isValueExist, rest);
}

function anyValueExist(...rest) {
    return R.any(isValueExist, rest);
}

function deepFreeze(o) {
    if (!o) {
        return o;
    }

    Object.freeze(o);

    Object.values(o).forEach((value) => {
        if (
            value &&
            (typeof value === 'object' || typeof value === 'function') &&
            !Object.isFrozen(value)
        ) {
            deepFreeze(value);
        }
    });

    return o;
}

function formatDataSize(bytes, decimals = 2) {
    if (!bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function handleScroll([entry]) {
    const { intersectionRatio, intersectionRect } = entry;

    return intersectionRatio > 0 && intersectionRect.y > 0;
}

function getChannelString(checkedCampaign) {
    const contains = R.contains(R.__, checkedCampaign.subChannels);
    if (checkedCampaign.channel === 'google') {
        if (contains('search')) return 'MANAGER.channel_google_search_campaign';
        else if (contains('display'))
            return 'MANAGER.channel_google_display_campaign';
        else if (contains('universal')) {
            return 'MANAGER.channel_google_universal_universalApp_campaign';
        } else return 'MANAGER.channel_google_campaign';
    } else if (checkedCampaign.channel === 'facebook') {
        if (contains('facebook') && contains('instagram'))
            return 'MANAGER.channel_facebook_instagram_campaign';
        else if (contains('instagram'))
            return 'MANAGER.channel_instagram_campaign';
        else return 'MANAGER.channel_facebook_campaign';
    } else {
        return `MANAGER.channel_${checkedCampaign.channel}_campaign`;
    }
}

function getChannelKey({ channel, subChannels }) {
    const contains = R.contains(R.__, subChannels);

    if (channel === 'facebook') {
        if (contains('facebook') && contains('instagram'))
            return 'instagram_facebook';
        else if (contains('instagram')) return 'instagram';
        else return 'facebook';
    } else {
        return channel;
    }
}

function getChannelTitle({
    channel = '',
    subChannels = [],
    creativeType = '',
}) {
    if (channel && isValueExist(subChannels) && creativeType)
        return `MANAGER.channel_${channel}_${subChannels[0]}_${creativeType}_campaign`;
}

const tagNameEq = R.curry((name, e) => {
    return R.pathSatisfies(
        R.both(R.test(new RegExp(name, 'gi')), R.propEq('length', name.length)),
        ['target', 'tagName'],
        e
    );
});

const maybeKorean = R.compose(({ language = '', country = '' }) => {
    language = language && language.toUpperCase();
    country = country && country.toUpperCase();

    return language === 'KO' || language === 'KR' || country === 'KR';
}, R.defaultTo({}));

const targetingKorea = R.T;

const headOfString = R.compose(R.head, R.defaultTo(''));

const randomInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1) + min);

const _formatProposal = R.pipe(
    R.clone,
    R.over(
        R.lensPath(['proposal', 'channelAds']),
        R.compose(
            R.map(
                R.ifElse(
                    R.pathEq(['executable', 'value'], false),
                    R.set(R.lensProp('enabled'), false),
                    R.identity
                )
            ),
            filterIdentity
        )
    )
);

const isSelfOrDescendant = R.curryN(2, (child, parent) => {
    if (!allValueExist(parent, child)) {
        return false;
    }

    let node = child;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
});

const notEnoughPermission = R.compose(
    R.pathEq(['response', 'status'], 403),
    R.defaultTo({})
);

const replaceComma = memoize(
    (value, format = '0,0') =>
        _numeral(value).format(format).replace(/ /gi, ','),
    (value, format = '0,0') => `${value}::${format}`
);

const srcset2X = (base = '') => {
    const [path, format] = base.split(/\.(png|jpg)$/);
    return [`${path}.${format} 1x`, `${path}@2x.${format} 2x`].join(', ');
};

const isNumber = R.is(Number);

const isValidAmountString = R.test(/^(?!,$)[\d,.]+$/g);

const arrayToObject = R.indexBy;

const isWebOrForm = R.test(/web|form/gi);

const testerFromArray = R.curryN(2, (arr = [], value) =>
    R.compose(
        R.test,
        (str) => new RegExp(str, 'gi'),
        R.join('|'),
        R.map((text) => `(${text})`)
    )(arr)(value)
);

const innerHtmlJSX = R.assocPath(['domProps', 'innerHTML'], R.__, {});

const popupSizeByType = (type) => {
    switch (type) {
        case 'tiktokAdAccount':
            return { width: '1024', height: '870' };
        default:
            return { width: '600', height: '700' };
    }
};

const showAuthLink = ({ type, cb = () => {}, cancelCb = () => {} }) => {
    // must remove event listener at destroyed lifecycle
    window.addEventListener('message', cb, false);

    const { width, height } = popupSizeByType(type);

    const popup = window.open(
        `${process.env.VUE_APP_API_URL}/link/${type}`,
        type,
        `toolbar=no, menubar=no, width=${width}, height=${height}, top=100, left=100`
    );

    const done$ = new Subject();

    timer(700, 500)
        .pipe(
            map(() => popup.closed),
            filter(R.identity),
            take(1),
            takeUntil(merge(done$, timer(60 * 1000 * 5)))
        )
        .subscribe(() => cancelCb());

    return () =>
        window.removeEventListener('message', () => {
            done$();
            cb();
        });
};

const checkOrigin = (checkOrigin) => {
    // const APP_STATUS = process.env.VUE_APP_STATUS;
    const ORIGIN = new Set([
        // `https://${APP_STATUS}.adriel.com`,
        // `https://${APP_STATUS}.adriel.ai`,
        // 'https://stg.adriel.com',
        process.env.VUE_APP_API_URL,
        process.env.VUE_APP_HOSTNAME,
        'https://api.adriel.com',
        'https://api.preprod.adriel.com',
    ]);
    return ORIGIN.has(checkOrigin);
};

const sanitizeEmoji = (str = '') =>
    str.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/gim,
        ''
    );

const listIncludes = R.curryN(2, (list = [], v) => {
    const _set = new Set(list);

    return _set.has(v);
});

const isFbFamilyString = listIncludes(['facebook', 'instagram']);

const guaranteeArray = R.unless(R.is(Array), R.of);

const extractExcelFileName = (headers) => {
    const contentDisposition = headers['content-disposition'];
    if (!contentDisposition) return '';

    const [fileNameMatch = []] = contentDisposition
        .split(';')
        .filter((str) => str.includes('filename'));

    return isValueExist(fileNameMatch)
        ? R.compose(R.takeLast(1), R.split('='))(fileNameMatch)
        : '';
};

const urlWithQueryString = (base = '', queryObj) =>
    !queryObj ? base : `${base}?${stringify(queryObj)}`;

const bgObject = memoize((bgColor) => {
    return !bgColor ? {} : Object.freeze({ 'background-color': bgColor });
});

const clearLocalStorage = () => {
    for (const property in LOCAL_STORAGE_KEYS) {
        const value = LOCAL_STORAGE_KEYS[property];
        localStorage.removeItem(value);
    }
};

export const hexToRGBA = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};

export const generateRandomRGB = () => {
    const max = 256;
    const [r, g, b] = ['r', 'g', 'b'].map(() =>
        Math.floor(Math.random() * max)
    );
    return `rgb(${r},${g},${b})`;
};

export const generateDarkRandomColorForGraph = () => {
    const genRangeRandomValue = (min, max) => Math.random() * (max - min) + min;

    const hueRange = genRangeRandomValue(160, 280);
    const saturationRange = genRangeRandomValue(50, 70);
    const lightnessRange = genRangeRandomValue(40, 60);

    const hue = Math.floor(hueRange);
    const saturation = Math.floor(saturationRange) + '%';
    const lightness = Math.floor(lightnessRange) + '%';

    return 'hsl(' + hue + ', ' + saturation + ', ' + lightness + ')';
};

export const getQueryStringParams = (name) => {
    let windowSearch = window.location.search;
    if (window.location.hash) {
        const sliceTo = window.location.hash.indexOf('?');
        windowSearch = window.location.hash.slice(sliceTo);
    }

    let match = RegExp('[?&]' + name + '=([^&]*)').exec(windowSearch);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export const changeOrder = ({ newIndex, oldIndex, value }) => {
    value = [...value];
    value.splice(newIndex, 0, value.splice(oldIndex, 1)[0]);

    return value;
};

export const valueFromEvent = R.path(['target', 'value']);

export const addIdUnless = R.over(
    R.lensProp('id'),
    R.unless(isValueExist, generateId)
);

export const isFloatNumber = (n) => n === +n && n !== (n | 0);

export const openFullscreen = (elem) => {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
    }
};

export const closeFullscreen = () => {
    if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
    } else if (this.document.webkitExitFullscreen) {
        /* Safari */
        this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
        /* IE11 */
        this.document.msExitFullscreen();
    }
};

export const indexById = R.indexBy(R.prop('id'));

export const notEq = R.complement(R.equals);

export const toggleInList = ({ pred, list, value }) => {
    pred = pred || R.equals(value);

    if (R.any(pred, list)) {
        list = R.reject(pred, list);
    } else {
        list = [...list, value];
    }

    return R.uniq(list);
};

export const preventDefault = result('preventDefault');

export const getFlooredFixed = (num, fixed = 2) => {
    if (num.includes('.')) {
        num = num.toString();
        num = num.slice(0, num.indexOf('.') + fixed);
    }
    return Number(num);
};

export const stopPropagation = result('stopPropagation');

export const downloadWithHref = (href) => {
    const link = document.createElement('a');
    link.download = extractExcelFileName(href);
    link.setAttribute('target', '_blank');

    link.href = href;
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const randomString = ({ excepts = {}, length = 12 } = {}) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var charactersLength = characters.length;

    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }

    // duplicate check here
    return excepts[result] ? randomString({ excepts, length }) : result;
};

export const findOr = R.curryN(
    3,
    (defaultValue, arr, pred) => (arr || []).find(pred) || defaultValue
);

export const replaceText = (mapper) => {
    return ({ text, keywords }) => {
        if (!text || !keywords) {
            return text;
        } else {
            try {
                const regEx = new RegExp(keywords, 'i');
                return text.replace(regEx, (keyword, _, matchedText) =>
                    matchedText.replace(matchedText, mapper(keyword))
                );
            } catch (e) {
                return text;
            }
        }
    };
};

export const refineClassName = (v = '') =>
    v
        .replace?.(/[\{\}\[\]\/?.,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/gi, '__')
        .replace?.(/ /g, '_');

export const fromMapByPropId = R.curryN(2, (map, { id }) => map[id]);

export const toPixel = (v) => v + 'px';

export const isSubset = R.curryN(2, (pArr = [], cArr = []) => {
    if (pArr.length < cArr.length) {
        return false;
    }

    const set = new Set(pArr);
    return R.all((v) => set.has(v), cArr);
});

export const getFrozenEmptyObj = () => {
    return Object.freeze({});
};

export const defaultToFrozenEmptyObj = R.unless(
    isValueExist,
    R.always(getFrozenEmptyObj())
);

export const isEllipsisActive = (el) => {
    return el.offsetWidth < el.scrollWidth;
};

export const isCamelCase = (name) => !name.match(/[\s_-]/g);

export const getImgStatus = async (src) => {
    return new Promise((res) => {
        const http = new XMLHttpRequest();

        http.open('HEAD', src, true);
        http.timeout = 10000;

        http.onload = function () {
            if (http.readyState === 4) {
                if (http.status === 200) {
                    res(200);
                } else {
                    res(400);
                }
            }
        };

        http.onerror = function () {
            res(400);
        };

        http.ontimeout = function () {
            res(400);
        };

        http.send();
    });
};

export const setUserToLocalStorage = (user) => {
    setLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_user`, user);
    setLocalStorage('adriel_user', user);
};

export const getUserFromLocalStorage = (user) => {
    return (
        getLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_user`) ||
        getLocalStorage('adriel_user', user)
    );
};

export const setAdrielJwt = (token) => {
    setLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt`, token);
    setLocalStorage('adriel_jwt', token);
    axios.defaults.headers.Authorization = 'Bearer ' + token;
};

export const getAdrielJwt = () => {
    return (
        getLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt`) ||
        getLocalStorage('adriel_jwt')
    );
};

export const removeAdrielJwt = () => {
    removeLocalStorageItem(`${process.env.VUE_APP_STATUS}::adriel_jwt`);
    removeLocalStorageItem('adriel_jwt');
    delete axios.defaults.headers.Authorization;
};

export const setAdrielJwtExpireTimeMilliseconds = (time) => {
    setLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt_exp`, time);
    setLocalStorage('adriel_jwt_exp', time);
};

export const getAdrielJwtExpireTimeMilliseconds = () => {
    return (
        getLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt_exp`) ||
        getLocalStorage('adriel_jwt_exp')
    );
};

export const removeAdrielJwtExpireTimeMilliseconds = () => {
    removeLocalStorageItem(`${process.env.VUE_APP_STATUS}::adriel_jwt_exp`);
    removeLocalStorageItem('adriel_jwt_exp');
};

export const setAdrielJwtRefreshToken = (token) => {
    setLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt_refresh`, token);
    setLocalStorage('adriel_jwt_refresh', token);
};

export const getAdrielJwtRefreshToken = () => {
    return (
        getLocalStorage(`${process.env.VUE_APP_STATUS}::adriel_jwt_refresh`) ||
        getLocalStorage('adriel_jwt_refresh')
    );
};

export const removeAdrielJwtRefreshToken = () => {
    removeLocalStorageItem(`${process.env.VUE_APP_STATUS}::adriel_jwt_refresh`);
    removeLocalStorageItem('adriel_jwt_refresh');
};

export const setAdrielJwtRefreshTokenExpireTimeMilliseconds = (time) => {
    setLocalStorage(
        `${process.env.VUE_APP_STATUS}::adriel_jwt_refresh_exp`,
        time
    );
    setLocalStorage('adriel_jwt_refresh_exp', time);
};

export const getAdrielJwtRefreshTokenExpireTimeMilliseconds = () => {
    return (
        getLocalStorage(
            `${process.env.VUE_APP_STATUS}::adriel_jwt_refresh_exp`
        ) || getLocalStorage('adriel_jwt_refresh_exp')
    );
};

export const removeAdrielJwtRefreshTokenExpireTimeMilliseconds = () => {
    removeLocalStorageItem(
        `${process.env.VUE_APP_STATUS}::adriel_jwt_refresh_exp`
    );
    removeLocalStorageItem('adriel_jwt_refresh_exp');
};

export const setAdrielTokens = ({
    token,
    refresh_token,
    expiration_time_token_seconds,
    expiration_time_refresh_seconds,
}) => {
    if (token) {
        setAdrielJwt(token);
    }

    if (refresh_token) {
        setAdrielJwtRefreshToken(refresh_token);
    }

    if (expiration_time_token_seconds) {
        setAdrielJwtExpireTimeMilliseconds(
            expiration_time_token_seconds * 1000
        );
    }

    if (expiration_time_refresh_seconds) {
        setAdrielJwtRefreshTokenExpireTimeMilliseconds(
            expiration_time_refresh_seconds * 1000
        );
    }
};

export const removeAdrielTokens = () => {
    removeAdrielJwt();
    removeAdrielJwtExpireTimeMilliseconds();
    removeAdrielJwtRefreshToken();
    removeAdrielJwtRefreshTokenExpireTimeMilliseconds();
};

export const isTokenExpiredByMilliseconds = (expMs) => {
    return moment().isSameOrAfter(expMs);
};

export const isAllPropsChanged = R.curryN(2, (list, props) =>
    R.all((key) => props.has(key), list)
);

export const isAnyPropsChanged = R.curryN(2, (list, props) =>
    R.any((key) => props.has(key), list)
);

export const clientLanguage = R.compose(
    (language) => (/ko|kr/gi.test(language) ? 'ko' : 'en'),
    R.defaultTo(''),
    R.head,
    filterIdentity,
    R.props(['userLanguage', 'language']),
    R.prop('navigator')
)(window);

import { readonly, ref } from 'vue';
import escapeRegExp from 'lodash/escapeRegExp';
export function useReactState(initialState) {
    const state = ref(initialState);
    const setState = (newState) => {
        state.value = newState;
    };
    return [readonly(state), setState];
}

export function looseSearch(arr = [], extractor = R.identity, keyword = '') {
    if (!keyword) {
        return arr;
    } else {
        const patternStr = escapeRegExp(
            keyword.replace(/\s/g, '').normalize('NFC')
        );
        const pattern = new RegExp(patternStr, 'i');
        return arr.filter((v) =>
            pattern.test(
                (extractor(v) || '').replace(/\s/g, '').normalize('NFC')
            )
        );
    }
}

export const checkConnected = R.propEq('status', MEMBER_STATUS.CONNECTED);

export const mapIndexed = R.addIndex(R.map);

export const checkPhoneValid = (value) => /^(?=.*\d)[\d ]+$/.test(value.trim());
export const checkValid = (value) => value.trim();

export const getErrorCodeFromServer = R.pathOr('', [
    'response',
    'data',
    'code',
]);

export const CLASS_JOIN = R.compose(R.join(' '), R.filter(R.identity));

export const logSM = (...val) => {
    console.log('SM', ...val);
};

export const nullablePathOr = R.curryN(3, (defaultValue, path, obj) => {
    const value = R.path(path, obj);
    const isValidValue =
        value !== undefined && !(typeof value === 'number' && isNaN(value));
    return isValidValue ? value : defaultValue;
});

const filterDeprecated = R.filter(R.propOr(false, 'isDeprecated'));

export const roundToN = (value, n) => {
    return Number(Math.round(value + 'e' + n) + 'e-' + n);
};

export {
    prependImageDest,
    prependFileDest,
    prependPublicImageDest,
    isValidEmail,
    upperHead,
    prependCurrency,
    adjustAndCurrency,
    fixedComma,
    toDate,
    isInRange,
    isValidUrl,
    isValidAppStoreUrl,
    isValidPlayStoreUrl,
    isValidPhoneNumber,
    mapPosition,
    makeExtensionChecker,
    getFacebookPages,
    countCharacters,
    isDoubleWidthCharacter,
    genericRetryStrategy,
    isValueExist,
    makeThumb,
    getImgSize,
    getVideoMeta,
    isVideoType,
    makeFixedComma,
    prependImageDestObject,
    getGa,
    insertGa,
    headFromArray,
    result,
    getFbLoginStatus,
    extractHostname,
    generateId,
    truncStr,
    getLang,
    setLocalStorage,
    getLocalStorage,
    capitalize,
    isValidBrowser,
    formatNumber,
    isMobile,
    toPercent,
    resizeInput,
    downloadFile,
    endsWithPunctuation,
    attachProtocol,
    upperWords,
    blur,
    height,
    outerWidth,
    filterIdentity,
    deleteElement,
    isUrl,
    allValueExist,
    deepFreeze,
    isImageType,
    getExtension,
    formatDataSize,
    handleScroll,
    isIE,
    tagNameEq,
    maybeKorean,
    headOfString,
    randomInt,
    getChannelString,
    targetingKorea,
    getChannelTitle,
    _formatProposal,
    isSelfOrDescendant,
    isKakaoBrowser,
    notEnoughPermission,
    srcset2X,
    replaceComma,
    isNumber,
    getChannelKey,
    isValidAmountString,
    arrayToObject,
    isWebOrForm,
    testerFromArray,
    innerHtmlJSX,
    showAuthLink,
    checkOrigin,
    sanitizeEmoji,
    isFbFamilyString,
    listIncludes,
    guaranteeArray,
    extractExcelFileName,
    anyValueExist,
    numeral,
    formatCurrency,
    urlWithQueryString,
    common,
    bgObject,
    getParameterByName,
    clearLocalStorage,
    noValueExist,
    removeZeros,
    filterDeprecated,
};
